import axios from "axios"
import { BASE_URL } from "../../global"

// activity_pdf.source doubles as the interactive worksheet flag. It is free text
// and has been saved with stray trailing whitespace, so always compare trimmed.
export const isInteractiveSource = source =>
  String(source == null ? "" : source)
    .trim()
    .toLowerCase() === "interactive"

/**
 * Asks whether an interactive worksheet can be auto-marked.
 *
 * @param {number|string} pdfId activity_pdf.id
 * @param {boolean} force re-read the PDF instead of using the stored verdict
 */
export const checkInteractiveWorksheet = async (pdfId, force = false) => {
  try {
    const response = await axios.post(BASE_URL + "activity/checkInteractiveWorksheet", {
      pdf_id: pdfId,
      force,
    })
    return response.data
  } catch (err) {
    return (
      err?.response?.data || {
        ok: false,
        code: "CHECK_FAILED",
        message: "The worksheet could not be checked",
      }
    )
  }
}

/**
 * What the tutor reads. The detail line exists so a screenshot is enough for us
 * to identify the worksheet and the fault without asking follow-up questions.
 */
export const describeVerdict = verdict => {
  if (!verdict) return null
  if (verdict.ok) {
    const fields = verdict.totalFields || 0
    const questions = verdict.totalQuestions || 0
    return {
      ok: true,
      headline: "Marked automatically",
      detail: `${questions} question${questions === 1 ? "" : "s"}, ${fields} answer box${
        fields === 1 ? "" : "es"
      }`,
    }
  }
  const reference = [verdict.code, verdict.worksheetId ? "worksheet " + verdict.worksheetId : null]
    .filter(Boolean)
    .join(" / ")
  return {
    ok: false,
    headline: "This worksheet cannot be marked automatically",
    detail: verdict.message || "",
    reference,
  }
}
